export default __webpack_public_path__ + "static/media/Zwergberg_Memento_Mori_Hoerprobe.3ead05b1.mp3";